module.exports = __webpack_public_path__ + "img/welcome.93a1fb86.png";